export enum Statuses {
  All = 'all',
  Active = 'active',
  Completed = 'completed',
}
